module.exports = __webpack_public_path__ + "img/lyndon-miles.118f7fd3.jpg";